// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ui_mesh.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'ui_meshPixelShader';
const shader = `precision mediump float;
varying vec4 vertexColor;
varying vec3 worldPosition;
void main() {
#ifdef WEBGL2
vec3 X = dFdx(worldPosition);
vec3 Y = dFdy(worldPosition);
vec3 normal = normalize(cross(X,Y));
vec3 shade = vertexColor.xyz * (normal.y * 0.25 + 0.75);
#else
vec3 shade = vertexColor.xyz;
#endif
gl_FragColor = vec4(shade, vertexColor.w);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ui_meshPixelShader = { name, shader };
//# sourceMappingURL=ui_mesh.fragment.js.map